const useHeadway = () => false;

export default useHeadway;
